import { FunctionComponent } from "react";
import BuyNowButton from "../shared/buy-now-button/buy-now-button";
import H2 from "../shared/html-tags/h2";
import H1 from "../shared/html-tags/h1";
import DIV from "../shared/html-tags/div";

export type Props = { newsPostTitle: string | undefined };

const NewsTopBanner: FunctionComponent<Props> = (props) => {
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------

  return (
    <div
      className="page-content bg-top-news top-banner"
      style={{ height: "25.25rem" }}
    >
      <div className="inner-content">
        <div
          className="top-left"
          style={{
            display: "flex",
            justifyContent: "stretch",
            alignItems: "center",
            marginLeft: "-8rem",
            paddingLeft: "8rem",
            backgroundImage: "url(/img/news/34-bang-300x300.png)",
            backgroundPosition: "0 17rem",
            backgroundRepeat: "no-repeat",
            backgroundSize: "12.5rem",
            height: "24.5rem",
          }}
        >
          <div>
            <H2 language="de">Blog & News</H2>
            <H1 language="de" style={{ lineHeight: "1.25" }}>
              Aktuelles von 2x4 und PS IMAGO{" "}
              <b style={{ color: "orange" }}>PRO</b>
            </H1>
            <H2
              language="de"
              style={{
                fontSize: "1.25rem",
                fontWeight: "bold",
                marginTop: "0.5rem",
              }}
            >
              {props.newsPostTitle ?? (
                <>
                  Erfahre alles über unsere neuesten Entwicklungen und
                  <br />
                  und Software Updates.
                </>
              )}
            </H2>
            <BuyNowButton order={"buy"} />
          </div>
        </div>
        <DIV language="de" className="top-right news-banner">
          <img
            src="/img/news/news-428x500.png"
            alt="Roboter liest die 2x4 PS IMAGO PRO News"
            style={{ border: "none", marginTop: "0", maxHeight: "25.25rem" }}
          />
        </DIV>
      </div>
    </div>
  );
};

export default NewsTopBanner;
